import { Cell, Text, VFlow } from 'bold-ui'
import { ErrorField } from 'components/form/final-form/ErrorField'
import { AgendamentosDiaQuery } from 'graphql/types.generated'
import React from 'react'
import { MetaPath } from 'util/metaPath'

import { AgendamentoDia } from '../types/AgendamentoDia'
import { AgendamentosDiaCheckField } from './AgendamentosDiaCheckField'

export type AgendamentosDiaFieldModel = AgendamentosDiaQuery['agendados']['content'][0]

export interface AgendamentosDiaFieldProps {
  name: MetaPath<string>
  agendamentosDia?: AgendamentoDia[]
  novoAtendimentoAgendadoName?: any
}

export function AgendamentosDiaField(props: AgendamentosDiaFieldProps) {
  const { name, agendamentosDia, novoAtendimentoAgendadoName } = props

  return (
    <>
      {!!agendamentosDia?.length && (
        <>
          <Cell size={5}>
            <VFlow vSpacing={0.5}>
              <Text fontWeight='bold'>Agendamentos do dia</Text>

              <VFlow>
                {agendamentosDia.map((agendamento: AgendamentosDiaFieldModel) => (
                  <AgendamentosDiaCheckField key={agendamento.id} name={name} agendamento={agendamento} />
                ))}
              </VFlow>

              {novoAtendimentoAgendadoName && <ErrorField name={novoAtendimentoAgendadoName} />}
            </VFlow>
          </Cell>

          <Cell size={7} />
        </>
      )}
    </>
  )
}
